import React from 'react'
import { ThemeProvider } from 'styled-components'
import { theme } from '../theme'
import Navbar from '../components/Navbar';
import Tutorials from '../components/Tutorials';
import Footer from '../components/Footer';
import SidebarTwo from '../components/SidebarTwo';

const Tutorial = ({isOpen, toggleSidebar}) => {

    return (
        <ThemeProvider theme={theme}>
            <SidebarTwo isOpen={isOpen} toggle={toggleSidebar} />
            <Navbar toggle={toggleSidebar} />
            <Tutorials />
            <Footer />
        </ThemeProvider>
    )
}

export default Tutorial